import { render } from "./menu.vue?vue&type=template&id=5a658031"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=5a658031&lang=css"

import exportComponent from "C:\\Users\\home\\Documents\\GitHub\\childu_usersite\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__